// extracted by mini-css-extract-plugin
export default {"groups":"Groups_groups__VEjUf"};